var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34809"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 141",
    cx: 16.0379,
    cy: 4.19027,
    r: 3.19027,
    fill: "white",
    stroke: "#797EDF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 142",
    cx: 16.0379,
    cy: 18.7762,
    r: 3.19027,
    fill: "white",
    stroke: "#797EDF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 143",
    cx: 4.19027,
    cy: 11.4832,
    r: 3.19027,
    fill: "white",
    stroke: "#797EDF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 157",
    x1: 6.09274,
    y1: 9.43085,
    x2: 13.4304,
    y2: 5.23793,
    stroke: "#797EDF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 158",
    x1: 6.48828,
    y1: 12.5809,
    x2: 13.8071,
    y2: 16.8065,
    stroke: "#797EDF",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.9a639284a130c5402a1dc1e35634db3a.svg";
export { ForwardRef as ReactComponent };